import {
    Building2Icon,
    CircleDollarSignIcon,
    GoalIcon,
    type LucideIcon,
} from 'smoothie';

/** Top-level Money Mapper rail sections. */
export type MoneyMapperPrimarySection = 'your-money' | 'goals' | 'accounts';

export interface MoneyMapperPrimaryNavRow {
    value: MoneyMapperPrimarySection;
    label: string;
    icon: LucideIcon;
}

export const MONEY_MAPPER_PRIMARY_ICONS: Record<
    MoneyMapperPrimarySection,
    LucideIcon
> = {
    'your-money': CircleDollarSignIcon,
    goals: GoalIcon,
    accounts: Building2Icon,
};

/** Sub-tabs under “Your money” (replaces the old segmented control). */
export type MoneyMapperYourMoneySubSegment =
    | 'take-home-pay'
    | 'bills'
    | 'spend'
    | 'current-assets';

export const MONEY_MAPPER_YOUR_MONEY_SUB_OPTIONS: Array<{
    value: MoneyMapperYourMoneySubSegment;
    label: string;
}> = [
    { value: 'take-home-pay', label: 'Take-home pay' },
    { value: 'bills', label: 'Bills' },
    { value: 'spend', label: 'Spend' },
    { value: 'current-assets', label: 'Current assets' },
];

export const buildMoneyMapperPrimaryNavRows =
    (): MoneyMapperPrimaryNavRow[] => {
        const items: Array<{
            value: MoneyMapperPrimarySection;
            label: string;
        }> = [
            { value: 'your-money', label: 'Your money' },
            { value: 'goals', label: 'Goals' },
            { value: 'accounts', label: 'Accounts' },
        ];
        return items.map((item) => ({
            ...item,
            icon: MONEY_MAPPER_PRIMARY_ICONS[item.value],
        }));
    };
